import { gql } from "@apollo/client";

export default gql`
  mutation removeYouTrackIntegrationMutation($organizationId: Int!) {
    removeYoutrackIntegration(organizationId: $organizationId) {
      organization {
        id
        hasYoutrackIntegration
        youtrackUrl
      }
    }
  }
`;
